import { BrandKitFontOption } from './types';

import { getEnv } from '@/constants';
import { BRAND_KIT_PATH } from '@/hooks/useCustomFont/constants';
import loggerService from '@/services/logger.service';
import { loadFont } from '@/utils/fonts';
import { encodeFileName, getDecodedFileNameFromUrl } from '@/utils/url';

export function getFormattedBrandKitBackground(background: string[], orgId: string) {
  return background.map(url => {
    const encodedFileName = encodeFileName(url);
    return `url(${getEnv('VUE_APP_CLOUD_FRONT_URL')}${BRAND_KIT_PATH}/${orgId}/${encodedFileName})`;
  });
}

export async function getFormattedBrandKitFonts(fonts: string[], orgId: string): Promise<BrandKitFontOption[]> {
  const fontPromises = fonts.map(async (font: string) => {
    const url = `${getEnv('VUE_APP_CLOUD_FRONT_URL')}${BRAND_KIT_PATH}/${orgId}/${font}`;
    const fontName = getDecodedFileNameFromUrl(url);

    let isLoaded = true;
    try {
      await loadFont(url, fontName);
    } catch (err) {
      loggerService.warn('Error loading font', err);
      isLoaded = false;
    }

    return {
      value: url,
      label: fontName,
      style: { fontFamily: fontName, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
      disabled: !isLoaded,
      tooltip: isLoaded ? '' : '@@translate@@ Failed to load font',
      tooltipSide: 'top',
      tooltipSideOffset: 1,
      isBrandKitFont: true
    };
  });

  return Promise.all(fontPromises);
}
